import LottiePlayer from 'components/lottie-player';
import scrollAnimation from 'components/lottie-player/animations/scroll-down.json';

import './Hero.css';

const Hero = ({ circulationData }) => {
  return (
    <div className="hero">
      <div className="container hero__container">
        <div className="hero__content">
          <div className="hero__caption">
            <p className="hero__title">1x2 TFC-də davam edir! <span style={{ display: 'block' }}>Cekpot uğrunda mübarizə artıq TFC-də!</span> </p>
            <p className="hero__description">CEKPOTU HƏDƏFLƏ!</p>
            {/* <p className="hero__amount">
              <span>{circulationData?.jackpotAmount}</span>
              <span>₼</span>
            </p> */}
            {/* <Link to="/bron" className="hero__link">
            İndi bron et
          </Link> */}
            <div className="hero__button">
              <a href="https://tfc.onelink.me/6Gkx/tgtfcyukle" target="_blank" className="hero__link">
                <div><img src="app-store-logo.svg" alt="App Store" /></div>
                <div className="hero__button-text">
                  <span>DOWNLOAD ON THE</span>
                  <span>App Store</span>
                </div>
              </a>
              <a href="https://tfc.onelink.me/6Gkx/tgtfcyukle" target="_blank" className="hero__link">
                <div><img src="google-play-logo.svg" alt="App Store" /></div>
                <div className="hero__button-text">
                  <span>DOWNLOAD ON THE</span>
                  <span>App Store</span>
                </div>
              </a>
            </div>
          </div>
          <div className="hero__telefon">
            <img src="tfc-telefon.png" alt="TFC Telefon" />
          </div>
        </div>
        <div className="hero__scroll">
          <span className="hero__scroll-text">Aşağı sürüşdür</span>
          <LottiePlayer
            animation={scrollAnimation}
            width="56px"
            height="56px"
          />
        </div>
      </div>
      <div className="hero__gradient"></div>
    </div>
  );
};

export default Hero;
